


























































import Vue from 'vue';
import moment from 'moment';
import StudioCommunityGroupThumbnail from '@/web/components/community/StudioCommunityGroupThumbnail.vue';
import { errorToMessage } from '@/core/utils/errors';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'StudioCommunityGroupCard',
  components: {
    StudioCommunityGroupThumbnail,
  },
  props: {
    group: {
      type: Object as () => CommunityGroupsResponse,
      required: true,
    },
    animated: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  methods: {
    dateFromNow(date) {
      return moment(date).fromNow();
    },
    isUserLeftThisGroup(group) {
      return group.user_left_this_group;
    },
    async rejoinGroup(group) {
      try {
        await this.$store.dispatch('community/rejoinGroup', {
          groupId: group.id,
          studioURL: this.studioURL,
        });
        group.user_left_this_group = false;
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'COMMUNITY.NOTIFICATIONS.YOU_SUCCESSFULLY_REJOINED_GROUP'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
    async leaveGroup(group) {
      try {
        await this.$store.dispatch('community/leaveGroup', {
          groupId: group.id,
          studioURL: this.studioURL,
        });
        group.user_left_this_group = true;
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('COMMUNITY.NOTIFICATIONS.YOU_SUCCESSFULLY_LEFT_GROUP'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
  },
});
